import { useMemo } from 'react';
import { getUserDetailsSuccessType, getUserDetailsErrorType, UserPermissions } from '../../../APIDocs/apiTypes';
import { useGetUserInfoQuery } from './useJbpQuery';
import { setUserAssociatedMpids } from '@/reducers/jbpGeneralSlice';
import { useAppDispatch } from '@/store';

export const useUserInfo = () => {
  const dispatch = useAppDispatch();
  const onUserInfoSuccess = (data: getUserDetailsSuccessType) => {
    dispatch(setUserAssociatedMpids(data.mpid));
  };

  const { data: userInfo, isLoading, isError: userDataError } = useGetUserInfoQuery<getUserDetailsSuccessType, getUserDetailsErrorType>(true, onUserInfoSuccess, undefined, 600000, 600000);

  const canAccess = (permission: keyof UserPermissions): boolean => {
    if (!userInfo) return false;
    return userInfo.permissions?.[permission] === true;
  };

  const isInternalUser = useMemo(() => {
    if (!userInfo) return false;
    return userInfo.userType === 'INTERNAL';
  }, [userInfo]);

  const isSupplierUser = useMemo(() => {
    if (!userInfo) return false;
    return userInfo.userType === 'SUPPLIER';
  }, [userInfo]);

  return { isUserInfoLoading: isLoading, userInfo, canAccess, isInternalUser, isSupplierUser, userDataError };
};
